import React from 'react'

import classNames from 'classnames'

import { clearFilters, removeFilter } from './filter-slice'
import style from './FilterPanel.module.css'
import { selectFilters } from './selectors'

import { ReactComponent as CrossIcon } from 'assets/icons/cross-icon.svg'
import { Badge, Stack } from 'common/components'
import { useAppDispatch, useAppSelector } from 'common/hooks'

type PropsType = {
  className?: string
}

export const FilterPanel = ({ className = '' }: PropsType) => {
  const dispatch = useAppDispatch()
  const currentFilters = useAppSelector(selectFilters)

  const clearFiltersHandler = () => {
    dispatch(clearFilters())
  }

  const removeFilterHandler = (filter: string) => {
    dispatch(removeFilter(filter))
  }

  if (currentFilters.length === 0) {
    return null
  }

  return (
    <div className={classNames(style.box, className)}>
      <Stack>
        {currentFilters.map(filter => (
          <Badge key={filter} variant="clearable" onClear={() => removeFilterHandler(filter)}>
            {filter}
          </Badge>
        ))}
      </Stack>
      <button
        className={style['clear-button']}
        aria-label="очистить фильтр"
        onClick={clearFiltersHandler}
      >
        <CrossIcon className={style.cross} />
      </button>
    </div>
  )
}
